<template>
  <div
    class="container"
    :class="{ lightBackground: !isDarkMode, darkBackground: isDarkMode }"
  >
    <vue-title title="WOLF | Sign in" />
    <Notification v-if="hasText" :text="text" />

    <div class="login">
      <img src="@/assets/wolf-darkMode.svg" alt="Logo" v-show="isDarkMode" />
      <img src="@/assets/wolf-lightMode.svg" alt="Logo" v-show="!isDarkMode" />
      <h4 :class="{ lightText: isDarkMode, darkText: !isDarkMode }">
        Sign into WOLF HQ
      </h4>
      <form @submit.prevent="onSubmit">
        <input
          type="email"
          placeholder="Email"
          autocomplete="on"
          :class="{
            lightField: isDarkMode,
            darkField: !isDarkMode,
            lightInput: isDarkMode,
            darkInput: !isDarkMode
          }"
          v-model="email"
          required
        />
        <input
          type="password"
          placeholder="Password"
          autocomplete="on"
          :class="{
            lightField: isDarkMode,
            darkField: !isDarkMode,
            lightInput: isDarkMode,
            darkInput: !isDarkMode
          }"
          v-model="password"
          required
        />
        <button>Sign In</button>
      </form>
      <RequestAccount />
      <router-link
        to="/recover"
        :class="{ lightLink: isDarkMode, darkLink: !isDarkMode }"
        >Forgot your password?</router-link
      >
      <ThemeSwitch />
    </div>
  </div>
</template>

<script>
import RequestAccount from "@/components/RequestAccount";
import ThemeSwitch from "@/components/ThemeSwitch";
import VueTitle from "@/components/VueTitle";
import Notification from "@/components/Notification";

import { auth } from "@/main";

export default {
  name: "SignIn",
  components: {
    RequestAccount,
    ThemeSwitch,
    VueTitle,
    Notification
  },
  data() {
    return {
      email: null,
      password: null,
      hasText: false,
      text: ""
    };
  },
  computed: {
    isDarkMode() {
      return this.$store.getters.isDarkMode;
    }
  },
  methods: {
    onSubmit() {
      const email = this.email;
      const password = this.password;

      auth
        .login(email, password, true)
        .then(() => {
          this.$router.replace("/");
        })
        .catch(error => {
          alert("Error: " + error);
        });
    }
  },
  mounted() {
    const params = this.$route.params;
    if (params.userLoggedOut) {
      this.hasText = true;
      this.text = "You have logged out";
    } else if (params.userRecoveredAccount) {
      this.hasText = true;
      this.text = `A recovery email has been sent to ${params.email}.`;
    } else if (params.userRequestedAccount) {
      this.hasText = true;
      this.text = `Your request for ${params.email} has been sent to an administrator.`;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: top;
  min-height: 100vh;
  padding-bottom: 24px;
  padding-top: 120px;
}
.login {
  width: 400px;
  text-align: center;
  margin-left: 16px;
  margin-right: 16px;
}

img {
  width: 150px;
  padding-bottom: 50px;
}
</style>
